import React from 'react';
// mui components
import { Grid } from '@mui/material';
// components
import CustomCard from '../../card';
import EmptyList from '../../empty-list';
import { IUploadItem } from 'redux-store/slices/file-cabinet-upload-slice';
import { UploadGridView } from '../../upload-grid-view';
import { DragAndDropWrapper } from 'components/file-cabinet-folders/modals/upload-file-modal/drag-and-drop-wrapper';
import { TrashFolderGridCard } from '../../deleted-view/components/trash-folder-grid-card';
// api
import { FileCabinetUserPermission, IFolder } from 'redux-store/api/file-cabinet';
import { IDeletedFilesProps } from 'components/file-cabinet-folders/modals/project-file-cabinet-modal/types';
// styles
import { styles } from './styles';

type Props = {
  folders?: IFolder[];
  className?: string;
  backUrl?: string | number;
  fromModal: boolean;
  projectFolderId?: string | number;
  projectId?: string | number;
  publicFolders?: boolean;
  myPermissions: FileCabinetUserPermission;
  fileCabinetUploads?: IUploadItem[];
  deletedFilesProps?: IDeletedFilesProps;
};

const FolderGridView: React.FC<Props> = ({
  folders,
  className = '',
  fromModal,
  projectFolderId,
  projectId,
  publicFolders,
  myPermissions,
  fileCabinetUploads,
  deletedFilesProps,
}) => {
  const { itemsCount, size, showDeletedFilesFolder, openDeletedFilesFolder } =
    deletedFilesProps || {};

  return (
    <DragAndDropWrapper
      fromModal={fromModal}
      projectFolderId={Number(projectFolderId)}
      projectId={Number(projectId)}
    >
      <Grid sx={styles(fromModal).wrapper}>
        {!!folders?.length || !!fileCabinetUploads?.length ? (
          <Grid sx={styles(fromModal).container} className={className}>
            {fileCabinetUploads?.map((item) => (
              <UploadGridView
                key={item?.tempId}
                size={item?.size}
                percent={item?.progress}
                mimeType={item?.mimeType}
                name={item?.fileName}
              />
            ))}
            {folders?.map((item, index) => {
              return (
                <CustomCard
                  key={`${item?.id}${index}`}
                  folder={item}
                  fromModal={fromModal}
                  projectFolderId={projectFolderId}
                  type={item?.type}
                  projectId={projectId}
                  publicFolders={publicFolders}
                />
              );
            })}

            {showDeletedFilesFolder && (
              <TrashFolderGridCard
                name="Trash"
                itemsCount={itemsCount}
                size={size}
                onClick={openDeletedFilesFolder}
              />
            )}
          </Grid>
        ) : (
          !publicFolders && (
            <EmptyList
              fromModal={fromModal}
              projectFolderId={projectFolderId}
              projectId={projectId}
              myPermissions={myPermissions}
            />
          )
        )}
      </Grid>
    </DragAndDropWrapper>
  );
};

export default FolderGridView;
